import { IActionFn, IPageData } from '@/store/types';
import { IModuleState } from './types';
import { $http } from '@/axios';
import { sleep } from '@/utils/helper';
import store from '@/store';

// 查询当前组织发起的申请列表
export const queryMyApplications: IActionFn<IModuleState> = async ({ commit, state }) => {
  try {
    commit('setMyApplications', { ...state.applyList, loading: true });
    const res: any[] = await $http.get('/v1/system/org/brandauthapplylist');
    commit('setMyApplications', { data: res });
  } catch (e) {
    commit('setMyApplications', { data: [] });
  }
};

// 查询当前组织已处理的申请日志
export const queryApplyLogs: IActionFn<IModuleState> = async ({ commit, state }, payload) => {
  try {
    commit('setApplyLogs', { ...state.applyLogs, loading: true });
    const res: IPageData = await $http.post('/v1/system/org/brandauthapplyloglist', payload);
    const { list: data, pageNum, pageSize, total } = res;
    commit('setApplyLogs', { data, pageNum, pageSize, total });
  } catch (e) {
    commit('setApplyLogs', { data: [], pageNum: 0, pageSize: 0, total: 0 });
  }
};

// 查询需要我审核的申请列表
export const queryMyAudits: IActionFn<IModuleState> = async ({ commit, state }) => {
  try {
    commit('setMyAudits', { ...state.auditList, loading: true });
    const res: any[] = await $http.get('/v1/system/org/brandauthapprovelist');
    commit('setMyAudits', { data: res });
  } catch (e) {
    commit('setMyAudits', { data: [] });
  }
};

// 查询我审核的申请日志
export const queryAuditLogs: IActionFn<IModuleState> = async ({ commit, state }, payload) => {
  try {
    commit('setAuditLogs', { ...state.auditLogs, loading: true });
    const res: IPageData = await $http.post('/v1/system/org/approvebrandauthloglist', payload);
    const { list: data, pageNum, pageSize, total } = res;
    commit('setAuditLogs', { data, pageNum, pageSize, total });
  } catch (e) {
    commit('setAuditLogs', { data: [], pageNum: 0, pageSize: 0, total: 0 });
  }
};

// 查询所有私有品牌
export const queryAllPrivateBrands: IActionFn<IModuleState> = async ({ commit, state }) => {
  try {
    commit('setAllPrivateBrands', { ...state.allPrivateBrands, loading: true });
    const res: any[] = await $http.post('/v1/baseinfo/brand/privatelist', {});
    commit('setAllPrivateBrands', { data: res });
  } catch (e) {
    commit('setAllPrivateBrands', { data: [] });
  }
};

// 批量添加授权申请
export const addApplications: IActionFn<IModuleState> = async ({ commit }, payload) => {
  try {
    commit('setLoading', true);
    await $http.post('/v1/system/org/addbrandauthapply', payload);
    store.commit('common/setToast', { visible: true, text: '提交成功，即将跳转到列表页面' });
    await sleep(1);
    commit('setLoading', false);
  } catch (e) {
    commit('setLoading', false);
  }
};

// 删除授权申请
export const deleteApplication: IActionFn<IModuleState> = async ({ commit, state }, payload) => {
  try {
    commit('setConfirm', { ...state.confirm, loading: true });
    await $http.post('/v1/system/org/cancelbrandauthapply', payload);
  } finally {
    commit('setConfirm', { visible: false });
  }
};

// 通过申请
export const acceptApplication: IActionFn<IModuleState> = async ({ commit }, payload) => {
  try {
    commit('setProcessing', true);
    await $http.post('/v1/system/org/approvebrandauth', payload);
    store.commit('common/setToast', { visible: true, text: '申请已通过' });
  } finally {
    commit('setProcessing', false);
  }
};

// 拒绝申请
export const rejectApplication: IActionFn<IModuleState> = async ({ commit, state }, payload) => {
  try {
    commit('setConfirm', { ...state.confirm, loading: true });
    await $http.post('/v1/system/org/approvebrandauth', payload);
    store.commit('common/setToast', { visible: true, text: '申请已拒绝' });
  } finally {
    commit('setConfirm', { visible: false });
  }
};
